export const GET_DICTIONARY_ORDER_STATUSES = Symbol('GET_DICTIONARY_ORDER_STATUSES');
export const GET_DICTIONARY_ORDER_STATUSES_REQUEST = Symbol('GET_DICTIONARY_ORDER_STATUSES_REQUEST');
export const GET_DICTIONARY_ORDER_STATUSES_SUCCESS = Symbol('GET_DICTIONARY_ORDER_STATUSES_SUCCESS');
export const GET_DICTIONARY_ORDER_STATUSES_ERROR = Symbol('GET_DICTIONARY_ORDER_STATUSES_ERROR');

